import React, { FC } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { NFCIcon } from '../../../assets/icons/NFCIcon';
import { COLORS } from '../../utils/Colors';
import { ChevronRightIcon } from '../../../assets/icons/ChevronRightIcon';
import { Separator } from '../Separator';
import { SignOutIcon } from '../../../assets/icons/SignOutIcon';
import { useMainContext } from '../../context/MainContext';
import { cleanAuthToken } from '../../utils/APIConfig';
import { Router } from '../../router/Router';

const Root = styled.div`
    margin-top: 15px;
    background: white;
    padding: 10px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 30px ${COLORS.VERY_LIGHT_GRAY};
    z-index: 1001;
    position: relative;
`;
const Decorator = styled.div`
    width: 15px;
    height: 15px;
    align-self: flex-end;
    transform: rotate(45deg);
    margin-top: -14px;
    margin-right: 2px;
    background: white;
`;
const Divider = styled.div`
    width: 100%;
    height: 1px;
    background: ${COLORS.VERY_LIGHT_GRAY};
    margin-block: 10px;
`;
const Name = styled.span`
    font-weight: 500;
`;
const Button = styled.button`
    width: 230px;
    display: flex;
    align-items: center;
    background: transparent;
    border: none;

    & > span {
        color: ${COLORS.LIGHT_GRAY};
        margin-inline: 10px;
        flex: 1;
    }
`;

interface Props {
  handleNFCCard: VoidFunction;
}

export const ProfileMenu: FC<Props> = ({ handleNFCCard }) => {
  const navigation = useNavigate();
  const { profile } = useMainContext();

  const handleSignOut = () => {
    cleanAuthToken();
    Router(navigation).goToWelcome();
  };

  return (
    <Root>
      <Decorator />
      <Name>{profile?.first_name} {profile?.last_name}</Name>
      <Divider />
      <Button type="button" onClick={handleNFCCard}>
        <NFCIcon width={16} height={16} color={COLORS.DARK_GRAY} />
        <span>Add smart card ID</span>
        <ChevronRightIcon width={16} height={16} color={COLORS.DARK_GRAY} />
      </Button>
      <Separator size="XS" />
      <Button type="button" onClick={handleSignOut}>
        <SignOutIcon width={16} height={16} color={COLORS.DARK_GRAY} />
        <span>Sign out</span>
        <ChevronRightIcon width={16} height={16} color={COLORS.DARK_GRAY} />
      </Button>
    </Root>
  );
};
